export const SUBTITLE = 'GET STARTED NOW'
export const TITLE = 'Join EconomyBookings Marketplace'

export const NEXT = 'Next'
export const BACK = 'Back'
export const SUBMIT = 'Submit'
